import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from '../store.js';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
	mode:'history',
  	routes, // short for routes: routes
  	linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
	const store_expire = store.getters.loginExpire>Vue.prototype.$moment().format('YYYY-MM-DD HH:mm:ss');
	if(store.getters.getApiKey!==null){
		Vue.prototype.$api.get('user/s/exist-api-key/'+store.getters.getApiKey).then(function(result){
			if(result.data==0){
				store.dispatch('logout');
			}
		});
	}
  	if (to.matched.some(record => record.meta.requiresAuth)) {
    	if(store_expire){
      		if(store.getters.isLoggedIn){
        		next()
        		if(to.matched.some(record => record.meta.requiresAdmin)){
          			if(store.getters.isAdmin){
           				next()
          			}
         			else{
            			next('/dashboard')
          			}
        		}
      		}
    	}
    	else{
    		store.dispatch('logout');
    	}
	} 
	else {
		next()
  	}
});

export default router;
